import { cva, type VariantProps } from "cva";

export const headlineStyles = cva({
  variants: {
    size: {
      "1": "text-headline-1",
      "2": "text-headline-2",
      "3": "text-headline-3",
      "4": "text-headline-4",
      "5": "text-headline-5",
      "6": "text-headline-6",
      "7": "text-headline-7",
    },
    weight: {
      normal: "font-normal",
      medium: "font-medium",
      bold: "font-bold",
    },
  },
});

export type HeadlineStylesProps = VariantProps<typeof headlineStyles>;
